import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ServicesView from '@/views/ServicesView.vue'
import ShiftsView from '@/views/ShiftsView.vue'
import AgentsView from '@/views/AgentsView.vue'
import VolumeTransactionsView from '@/views/VolumeTransactionsView.vue'
import OneDayPlanView from '@/views/OneDayPlanView.vue'
import WeeklyPlanningView from '@/views/WeeklyPlanningView.vue'
import BreaksView from '@/views/BreaksView.vue'
import CoveragePerformanceView from '@/views/CoveragePerformanceView.vue'
import ExportsView from '@/views/ExportsView.vue'
import Login from '@/layout/Login.vue'
import Main from '@/layout/Main.vue'
import PlanningView from '@/views/PlanningView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/main',
    redirect: '/main/home'
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/main',
    name: 'main',
    component: Main,
    children: [
      {
        path: 'home',
        name: 'home',
        component: HomeView
      },
      {
        path: 'services',
        name: 'services',
        component: ServicesView
      },
      {
        path: 'shifts',
        name: 'shifts',
        component: ShiftsView
      },
      {
        path: 'agents',
        name: 'agents',
        component: AgentsView
      },
      {
        path: 'volumetransactions',
        name: 'volumetransactions',
        component: VolumeTransactionsView
      },
      {
        path: 'onedayplan',
        name: 'onedayplan',
        component: OneDayPlanView
      },
      {
        path: 'weeklyplanning',
        name: 'weeklyplanning',
        component: WeeklyPlanningView
      },
      {
        path: 'breaks',
        name: 'breaks',
        component: BreaksView
      },
      {
        path: 'coverageperformance',
        name: 'coverageperformance',
        component: CoveragePerformanceView
      },
      {
        path: 'exports',
        name: 'exports',
        component: ExportsView
      },
    ]
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
